import { useMemo } from 'react';

import type {
  Attendee,
  EventStandardFields,
} from 'hb-react/shared/apps/Events/types';
import {
  Telephone,
  Text,
} from 'hb-react/shared/components/formik/components/inputs';

const standardFieldsLabels = {
  mobile_phone: I18n.t('web.networks.events.tickets.list.phone_number'),
  company_name: I18n.t('web.networks.events.tickets.list.company_name'),
  custom_field_1: I18n.t('web.networks.events.tickets.list.custom_field_1'),
  custom_field_2: I18n.t('web.networks.events.tickets.list.custom_field_2'),
  custom_field_3: I18n.t('web.networks.events.tickets.list.custom_field_3'),
};

const Field = ({
  Component,
  id,
  label,
  labelMultiline,
  name,
  onUpdate,
  onBlur,
  placeholder,
  required,
}) => (
  <Component
    data-testid={id}
    name={name}
    label={label}
    labelMultiline={labelMultiline}
    placeholder={placeholder}
    onChange={(value) => onUpdate(value)}
    onBlur={onBlur}
    validate={{
      required,
    }}
    wrapperProps={{
      mb: 0,
    }}
  />
);

const FieldTypes = {
  mobile_phone: Telephone,
};

export const StandardFields = ({
  name,
  fields = {},
  onUpdate = () => {},
  onBlur = () => {},
}: StandardFieldsProps) => {
  const standardFields = useMemo(() => Object.values(fields), [fields]);

  if (standardFields.length === 0) {
    return null;
  }

  return (
    <>
      {standardFields.map(({ label, id, name: fieldName, ...props }) => (
        <Field
          key={id}
          Component={FieldTypes[fieldName] || Text}
          id={id}
          name={`${name}[${fieldName}]`}
          label={label || standardFieldsLabels[fieldName]}
          labelMultiline
          onUpdate={(value) => onUpdate({ [fieldName]: value })}
          onBlur={() => onBlur(fieldName)}
          {...props}
        />
      ))}
    </>
  );
};

interface StandardFieldsProps {
  name: string;
  fields: EventStandardFields;
  onUpdate?: (args: { [key: StandardFieldsProps['name']]: string }) => void;
  onBlur?: (name: keyof Attendee) => void;
  Wrapper?: any;
}
